import type {TuiLanguageCommerce} from '@taiga-ui/i18n/types';

export const TUI_ENGLISH_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Number', 'Card number'],
    cardExpiry: ['Expires', 'Valid through'],
};
